import { handlers as useCybertronThemeHandlers } from '@sbu/hooks.cybertrontheme/build/mocks';
import { handlers as usePermissionsHandlers } from '@sbu/hooks.permissions/build/mocks';
import { handlers as userDateTimePreferencesHandlers } from '@sbu/hooks.time/build/mocks';
import { handlers as featureFlagHandlers } from '@sbu/views.featureflags/build/mocks';
import { handlers as navHandlers } from '@sbu/views.nav/build/mocks';
import { handlers as ruleLabelHandlers } from '@sbu/views.rulelabel/build/mocks';

import { handlers as automationConfigHandlers } from 'app/Config/Automation/mocks';
import { handlers as enrichmentsFilterHandlers } from 'app/Enrichments/EnrichmentsFilter/mocks';
import { handlers as insightStatusMetricsHandlers } from 'app/Hud/InsightStatusMetrics/mocks';
import { handlers as insightEntityAutomationFormHandlers } from 'app/InsightDetail/InsightEntityAutomationForm/mocks';
import { handlers as insightEntityRelationshipsHandlers } from 'app/InsightDetail/InvolvedEntities/InsightEntityRelationships/mocks';
import { handlers as entityAsideHandlers } from 'shared/components/internal/EntityAside/mocks';

import * as mutations from './mutations';
import * as queries from './queries';

const allQueries = Object.values(queries).flatMap((q: any[]) => q);
const allMutations = Object.values(mutations).flatMap((m: any[]) => m);

export const handlers = [
  ...allQueries,
  ...allMutations,
  // Views (may contain queries and mutations per view)
  ...automationConfigHandlers,
  ...usePermissionsHandlers,
  ...useCybertronThemeHandlers,
  ...enrichmentsFilterHandlers,
  ...featureFlagHandlers,
  ...ruleLabelHandlers,
  ...insightStatusMetricsHandlers,
  ...navHandlers,
  ...entityAsideHandlers,
  ...insightEntityAutomationFormHandlers,
  ...insightEntityRelationshipsHandlers,
  ...userDateTimePreferencesHandlers,
];
